import getTaskFolderName from './getTaskFolderName';
import { updateTaskFolderService } from 'owa-todo-service';

/**
 * Checks to see if the tasks folder is using 'Project Moca - '
 * or 'Spaces - ' as the prefix for task folders. If so,
 * update it to 'Calendar Board - '.
 *
 * @param folderId tasks parent folder id to change
 * @param oldFolderName the tasks parent folder name
 * @param projectName the current project name in Spaces
 */
export default function updateLegacyTasksFolderName(
    folderId: string,
    oldFolderName: string,
    projectName: string
): void {
    const spacesRegex = /^Project Moca - | ^Spaces - /g;
    const isUsingLegacyName = spacesRegex.test(oldFolderName);

    if (isUsingLegacyName) {
        updateTaskFolderService(folderId, { Name: getTaskFolderName(projectName) });
    }
}
